import script from "./MValuesItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MValuesItem.vue?vue&type=script&setup=true&lang=js"

import "./MValuesItem.vue?vue&type=style&index=0&id=4a14942f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a14942f"]])

export default __exports__